import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trpc } from '../trpc';

export function NewsletterForm() {
  const { t, i18n } = useTranslation('common');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const subscribe = trpc.subscribe.useMutation({
    onSuccess() {
      setSubmitted(true);
    },
  });

  const language = i18n.language.startsWith('pl') ? 'pl' : 'en';

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    subscribe.mutate({ email, language });
  }

  if (submitted) {
    return (
      <p className='text-sm font-medium text-accent'>
        {t('newsletter.success')}
      </p>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className='flex w-full max-w-lg flex-col gap-2 sm:flex-row sm:items-center'
    >
      <label htmlFor='newsletter-email' className='sr-only'>
        {t('newsletter.emailPlaceholder')}
      </label>
      <input
        id='newsletter-email'
        type='email'
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('newsletter.emailPlaceholder')}
        className='flex-1 rounded-full border border-border bg-bg px-5 py-3 text-base text-fg placeholder:text-fg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-bg'
      />
      <button
        type='submit'
        disabled={subscribe.isPending}
        className='rounded-full bg-accent px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-bg'
      >
        {subscribe.isPending ? t('newsletter.sending') : t('newsletter.cta')}
      </button>
      {subscribe.isError && (
        <p className='w-full text-xs text-red-500'>{t('newsletter.error')}</p>
      )}
    </form>
  );
}
